import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import FeaturedMovies from './components/FeaturedMovies';
import CategorySection from './components/CategorySection';
import FAQSection from './components/FAQSection';
import Footer from '@/components/feature/Footer';
import { categories, movies } from '@/mocks/movies';

const pageTitle = '琪琪影院 - 电影大全最新电影热门电影 | 科幻电影动作电影高清蓝光免费在线看';
const pageDescription = '琪琪影院打造电影大全在线观看，最新电影热门电影一网打尽，科幻电影动作电影高清蓝光画质免费看不缓冲，海量片库持续更新。';
const pageKeywords = '电影大全,最新电影,热门电影,科幻电影,动作电影,琪琪影院,高清电影在线看,免费电影大全,蓝光电影不缓冲';
const canonicalUrl = 'https://qiqicinema.com';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '琪琪影院',
  url: canonicalUrl,
  description: pageDescription,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${canonicalUrl}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '琪琪影院',
  url: canonicalUrl,
  description: pageDescription,
  email: 'contact@qiqicinema.com',
  telephone: '+86-400-888-6666',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '建国路88号SOHO现代城A座',
    addressLocality: '北京',
    addressRegion: '朝阳区',
    addressCountry: 'CN',
  },
};

export default function Home() {
  return (
    <>
      <SEO
        title={pageTitle}
        description={pageDescription}
        keywords={pageKeywords}
        canonicalUrl={canonicalUrl}
        ogImage="https://readdy.ai/api/search-image?query=QiQi%20Cinema%20movie%20streaming%20website%20homepage%2C%20dark%20cinema%20theme%2C%20film%20reels%2C%20golden%20accents%2C%20brand%20identity&width=1200&height=630&seq=home-og&orientation=landscape"
      />
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedMovies />
          <CategorySection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}